<template>
    <div class="catList_item" >
        <product-label :product="product" />
        <div class="catList_item_cats">
            <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_cats_cat text-orange" v-if="product.is_new">Новинка</a>
            <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_cats_cat" v-if="product.has_discount">скидка</a>
            <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_cats_cat" v-if="product.is_top">выбор покупателей</a>
        </div>
        <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_img">
            <img :src="product.list_image" :alt="product.brand_name + ' ' + product.name + ' ' + product.articul" />
        </a>
        <a :href="'/catalog/item/' + (category.catalog_code ? category.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="catList_item_name">
            {{ product.name }}
        </a>
        <div class="catList_item_inf">
            <div class="catList_item_inf_box">
                <div class="catList_item_inf_name">
                    Артикул
                </div>
                <div class="catList_item_inf_value">
                    {{ product.articul }}
                </div>
            </div>
            <div class="catList_item_inf_box">
                <div class="catList_item_inf_name">
                    Код
                </div>
                <div class="catList_item_inf_value">
                    {{ product.code }}
                </div>
            </div>
            <div class="catList_item_inf_box">
                <div class="catList_item_inf_name">
                    {{ product.smart_stock_label }}
                </div>
                <div class="catList_item_inf_value" v-if="product.has_stock">
                    {{ product.smart_stock }}
                </div>
            </div>
        </div>
        <div class="catList_item_price" v-if="product.current_price && product.current_price.amount > 0">
            <div class="catList_item_price_value">
                <money :price="product.current_price" />
            </div>
            <div class="catList_item_price_old" v-if="product.has_discount">
                <money :price="product.base_price" />
            </div>
        </div>
        <div >
            <buy-button v-if="product.has_stock" :product="product" mode="catalog"></buy-button>
            <add-to-wait-list-button v-if="!product.has_stock" :product="product"></add-to-wait-list-button>
        </div>
    </div>
</template>

<script>
    import Money from "../core/Money";
    import BuyButton from "./BuyButton";
    import AddToWaitListButton from "./AddToWaitListButton";
    import ProductLabel from "./ProductLabel";

    export default {
        name: 'Product',
        components: {AddToWaitListButton, ProductLabel, Money, BuyButton},
        props: ['product','category','basePath']

    }
</script>

<style scoped>

</style>
